<ion-content>
  <div class="constrained-content">
    <ion-grid class="constrained-content">
      <ion-row>
        <ion-col size-md="4" size="12" class="settings-title-section">
          <h1><ion-icon name="people-circle-outline"></ion-icon>User Groups</h1>
          <p class="subtitle">
            Create groups that can be used in assignments and notifications.
            Groups can be defined manually or automatically populated based on
            Slack User Groups, SCIM/Okta groups, or user attributes.
          </p>
        </ion-col>
        <ion-col size-md="8" size="12">
          <div class="flex-space-between" style="padding: 15px 5px 0 3px">
            <div class="button-container flexed-align-center">
              <ion-searchbar
                mode="ios"
                placeholder="Search..."
                showCancelButton="never"
                [(ngModel)]="searchText"
                (ionChange)="getUserGroups()"
                class="rounded-search-bar"
              >
              </ion-searchbar>
              <ion-select
                interface="popover"
                placeholder="Scope"
                aria-label="Select scope"
                class="select-outline input-field"
                style="height: 36px; margin: 0"
                [(ngModel)]="filteringByProject"
                (ionChange)="getUserGroups()"
                [compareWith]="compareWith"
                [hidden]="!authService.selectedProject?.id"
              >
                <ion-select-option [value]="false"
                  >All Groups</ion-select-option
                >
                <ion-select-option [value]="true"
                  >Groups in This Project</ion-select-option
                >
              </ion-select>
            </div>

            <div class="button-container flexed-align-center">
              <ion-button
                (click)="createUserGroup()"
                *ngIf="canCreateUserGroup"
              >
                <ion-icon name="add-outline"></ion-icon>
                <span class="text-with-left-icon hidden-sm">
                  Create user group
                </span>
              </ion-button>
            </div>
          </div>
          <ion-card class="outline-card" style="margin: 18px">
            <ngx-datatable
              class="material datatable-row-borders"
              columnMode="force"
              [limit]="100"
              [headerHeight]="46"
              [footerHeight]="50"
              [rowHeight]="50"
              [scrollbarH]="true"
              [rows]="userGroups"
              [reorderable]="true"
            >
              <ngx-datatable-column
                name="Name"
                prop="name"
                [minWidth]="100"
                [width]="200"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <a style="font-weight: 500" (click)="editUserGroup(row.id)">{{
                    value
                  }}</a>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Type"
                prop="isExternal"
                [minWidth]="100"
                [width]="100"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <ion-badge color="light" *ngIf="!value"
                    ><ion-icon name="people-circle"></ion-icon>
                    Internal</ion-badge
                  >
                  <ion-badge color="light" *ngIf="value">
                    <ion-icon name="globe"></ion-icon> External
                  </ion-badge>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Description"
                prop="description"
                [minWidth]="100"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <span [title]="value">{{ value }}</span>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Source"
                prop="sourceType"
                [minWidth]="100"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <ion-badge color="light">
                    {{ getSourceLabel(row.sourceType) }}
                  </ion-badge>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Created at"
                prop="createdAt"
                [minWidth]="120"
                [maxWidth]="120"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  {{ value | date: "M/d/yyyy" }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
